// extracted by mini-css-extract-plugin
export default {"container":"text-area_container__4McsR","input":"text-area_input__Erlek","label":"text-area_label__BwnFS"};